import _ from 'lodash';
import { FEATURES } from '@common/types';
import { MultiFilterSelections } from './MultiSelectionFilter';

const showInfoIconList: string[] = [FEATURES.CMS, FEATURES.USER_CODE];

export const getSelectedValues = (
  selections: MultiFilterSelections,
  eventData: { id: string; checked: boolean },
) => {
  const isChecked = eventData.checked;
  const modifiedSelectionId = eventData.id;

  const selectedValues = _.map(selections, (selection) => {
    if (selection.id === modifiedSelectionId) {
      return { ...selection, isChecked };
    }
    return selection;
  });

  return selectedValues;
};

export const getQueryParamsFromMultiSelection = (
  updatedQueryParam: string,
  selectedValues: MultiFilterSelections,
) => {
  return {
    [updatedQueryParam]: _.map(
      _.filter(selectedValues, 'isChecked'),
      (i) => i.id,
    ).join(','),
  };
};

export const getMultiFilterSelectionsFromIds = ({
  items,
  selectionIds,
  showInfoIcons,
  wasCleared,
}: {
  items: Record<string, string>;
  selectionIds: Array<string>;
  showInfoIcons?: boolean;
  wasCleared?: boolean;
}) => {
  const selectedValues = _.map(items, (item) => {
    return {
      isChecked: wasCleared ? false : _.indexOf(selectionIds, item) > -1,
      id: item,
      label: item,
      showInfoIcon:
        Boolean(showInfoIcons) && showInfoIconList.indexOf(item) !== -1,
    };
  });

  return selectedValues;
};

export const getActiveMultiSelectionFiltersCount = (
  options: MultiFilterSelections,
) => {
  let count = 0;
  for (let i = 0; i < options.length; i++) {
    count += Number(options[i].isChecked);
  }
  return count;
};
